const LOAD_DEPLOYMENTS_SUCCESS = "deployments::load-all::success";
const LOAD_DEPLOYMENTS_FAILURE = "deployments::load-all::failure";

export { LOAD_DEPLOYMENTS_SUCCESS, LOAD_DEPLOYMENTS_FAILURE };
